module.exports = __webpack_public_path__ + "static/media/Heroic Knight.9b07987b.jpg";